var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { utilSVG } from "../../../utils/svg/utilSVG";
import { IdTutorialFocusElement } from "../IdTutorialFocusElement";
export var TutorialBackground = React.memo(function (_a) {
    var rect = _a.rect, ellipsePath = _a.ellipsePath;
    var fullScreenPath = utilSVG.fullScreenPath(0);
    var overlayStyle = {
        fillOpacity: 0.5,
    };
    if (rect) {
        var center = utilSVG.rectCenter(rect);
        overlayStyle = __assign({}, overlayStyle, { transformOrigin: center.x + "px " + center.y + "px" });
    }
    var eventProxy = ellipsePath ? (React.createElement("path", { className: "tutorial-background__event-proxy", d: ellipsePath })) : (undefined);
    var overlayPath = ellipsePath ? fullScreenPath + ellipsePath : fullScreenPath;
    return (React.createElement("div", { className: "tutorial-background tutorial-background-dom" },
        React.createElement("svg", { className: "tutorial-background__cover", width: "100%", height: "100%", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { id: "" + IdTutorialFocusElement.tutorial_background, className: "tutorial-background__overlay", d: overlayPath, style: overlayStyle }),
            React.createElement("path", { className: "tutorial-background__block-inputs", d: fullScreenPath }),
            eventProxy)));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/components/TutorialBackground.tsx
// module id = 481
// module chunks = 3